export const condensedListStyleClassMap: Record<string, string> = {
  default: "",
  boxed: "-rotate-1 border-2 border-solid border-black container-sm p-4 bg-white",
};

export type TCondensedListStyle = keyof typeof condensedListStyleClassMap;
